<template>
  <router-link :to="to">
    <slot />
  </router-link>
</template>
<script>
import { TRACKS_URL } from '@/modules/track/track.constants';

export default {
  name: 'DaraTrackLink',
  props: {
    id: {
      type: String,
      required: true,
    },
    slug: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: 'view',
      validator(action) {
        return action && ['view', 'edit'].includes(action);
      },
    },
  },
  computed: {
    to() {
      if (this.slug) {
        return {
          name: TRACKS_URL[this.action].name,
          path: TRACKS_URL[this.action].path,
          params: { id: this.id },
          query: { name: this.slug },
        };
      }
      return {
        name: TRACKS_URL[this.action].name,
        path: TRACKS_URL[this.action].path,
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>
